export default "__VITE_ASSET__D_4unW9S__"